import Vue from 'vue';
import LoginElement from './LoginElement.vue';

function initLogin() {
    const element = document.querySelector('.loginform');

    if (element) {
        new Vue({
            name: 'LoginElement',
            el: '.loginform',
            components: {
                LoginElement,
            },
        });
    }
}

document.addEventListener('DOMContentLoaded', initLogin);
window.addEventListener('Pageeditor:insert', initLogin);
window.addEventListener('Pageeditor:change', initLogin);